import React from 'react'

function PendingReviewIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      fill="none"
      {...props}
    >
      <circle cx={13} cy={13} r={13} fill="#78787B" />
      <path
        stroke="#fff"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M5.475 13.613a1.888 1.888 0 0 1 0-1.226C6.553 9.252 9.515 7 13 7c3.485 0 6.447 2.252 7.525 5.387.136.397.136.829 0 1.226C19.447 16.748 16.485 19 13 19c-3.485 0-6.447-2.252-7.525-5.387Z"
      />
      <circle
        cx={13}
        cy={12.999}
        r={2.083}
        stroke="#fff"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  )
}
export default PendingReviewIcon
